import React, { useEffect, useState } from 'react';
import CustomGrid from '../CustomGrid';
import GridConfig from './gridConfig';
import { constructShipmentsStatusBar, getShipmentsData } from '../../../utils';
import { withStyles } from '@material-ui/core';
import GeoCodingComponent from '../../../../../../../modules/Common/Geocoding/GeoCodingComponent';
import { getShipmentCustomerData } from '../../../../../../../modules/Common/Geocoding/utils';
import { autorun } from 'mobx';
import ValidationReason from '../../ValidationReason';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const styles = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '30px',
    height: '100%'
  },
  leftContainer: {
    flex: 0.4,
    minWidth: 400,
    display: 'flex',
    flexDirection: 'column'
  },
  geoCodingContainer: {
    flex: 0.6,
    minWidth: 600,
    border: `1px solid ${theme.printTableBorder}`,
    borderRadius: 4,
    padding: 16
  },
  messageText: {
    color: theme.disableButtonText,
    fontWeight: 500
  },
  messageContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 5
  }
});

const ShipmentDistance = ({
  classes,
  userData,
  data,
  IBPlanningStore,
  glEventHub,
  currentStepMessage
}) => {
  const [shipments, setShipments] = useState([]);
  const [geocodeShipment, setGeocodeShipment] = useState(null);
  const { userProfile } = userData;
  const [gridApi, setGridApi] = useState(null);

  useEffect(() => {
    const dispose = autorun(populateShipmentsData);
    return () => dispose(); // Cleanup autorun on unmount
  }, [data]); // Re-run when `data` reference changes

  const populateShipmentsData = () => {
    if (data) {
      const shipmentsData = getShipmentsData({
        proIdList: data,
        shipmentsList: IBPlanningStore.shipmentsList
      });
      setShipments(shipmentsData);
    }
  };

  const onGridReadyHandler = (api) => {
    if (api) {
      api.runCommand = runCommand;
      setGridApi(api);
    }
  };

  const runCommand = (command, data) => {
    /* once Latitude/Longitude get updated using geocoding popup in grid, we need to show updated marker in geocoding popup map */
    if (command === 'openGeoCodeModel') {
      const geocodeShipment = getShipmentCustomerData(data);
      setGeocodeShipment(geocodeShipment);
    }
  };

  const closeGeocodeModal = (hasDataChanged = false) => {
    if (hasDataChanged && geocodeShipment) {
      glEventHub.emit('DispatchEvents', 'RefreshIBStore', [
        {
          showNotification: false,
          selectedShipmentsList: [geocodeShipment.proId]
        }
      ]);
    }
    setGeocodeShipment(null);
  };

  return (
    <div className={classes.container}>
      <div className={classes.leftContainer}>
        <ValidationReason message={currentStepMessage} />
        <div className={classes.messageContainer}>
          <p className={classes.messageText}>
            You can exclude these shipments from the routing process or fix their geocodes to bring
            them within the routing range.
          </p>
          <ClearAllFilterButton gridApi={gridApi} />
        </div>
        <CustomGrid
          GridConfig={GridConfig}
          data={shipments}
          showSearchBar
          hideHeader
          onGridReadyHandler={onGridReadyHandler}
          constructStatusBar={constructShipmentsStatusBar}
        />
      </div>
      {geocodeShipment && (
        <div className={classes.geoCodingContainer}>
          <GeoCodingComponent
            key={geocodeShipment.code}
            customer={geocodeShipment}
            userData={userProfile}
            close={closeGeocodeModal}
          />
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(ShipmentDistance);
